import { fill, isEmpty, uniqueId } from 'lodash'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { fetchChannel, fetchChannelGifs } from 'shared/api/channels'
import SharedCarousel from 'shared/components/carousel/carousel'
import gifSkeleton from 'shared/components/gif-skeleton'
import Observer from 'shared/components/observer'
import { giphyAqua, giphyCornflower, giphyIndigo, giphyPink } from 'shared/css/colors.css'
import channelProps from 'shared/prop-types/channel'
import ChannelCarouselItem from './carousel-item'
import css from './carousels.css'

const MAX_CAROUSEL_ITEMS = 3
const colors = [giphyAqua, giphyPink, giphyIndigo, giphyCornflower]

const createGif = ({ featured_gif, url, short_display_name, display_name, is_private: channelIsPrivate }) => ({
    ...featured_gif,
    label: short_display_name || display_name,
    url,
    channelIsPrivate,
})

const Carousel = styled(SharedCarousel)`
    overflow: hidden;
`

export class CarouselSection extends PureComponent {
    state = {
        isVisible: false,
        backgroundColor: colors[this.props.index % colors.length],
        channel: this.props.channel,
        gifs: [],
    }
    gridId = uniqueId('carousel-section')
    render() {
        const {
            isVisible,
            backgroundColor,
            channel: {
                has_children: hasChildren,
                id,
                display_name: title,
                is_private: isPrivate,
                url: titleUrl,
                content_type: contentType,
                children,
            },
        } = this.state
        // gifs that have been fetched, may be overwritten
        let { gifs } = this.state

        const onChannel = channel => this.setState({ channel })
        const onGifs = gifs => {
            if (gifs.length === 0) {
                this.setState({ backgroundColor: 'transparent' })
            } else {
                this.setState({ gifs })
            }
        }

        const onVisible = async isVisible => {
            if (isVisible && usingPlaceholderGifs) {
                this.setState({ isVisible: true })
                if (hasChildren) {
                    const channel = await fetchChannel(id)
                    onChannel(channel)
                } else {
                    const { data: gifs } = await fetchChannelGifs(id)
                    onGifs(gifs)
                }
            }
        }

        const { index, autoPlay, className } = this.props

        let preloadIndex = index * 100
        let usingPlaceholderGifs = false

        if (hasChildren && !isEmpty(children)) {
            // get the channels that have been fetched
            gifs = children.map(createGif)
        }
        // if no gifs, create placeholder gifs
        if (isEmpty(gifs)) {
            // branch channel carousel items have labels, leaf items don't
            gifs = fill(Array(3), gifSkeleton({ label: hasChildren ? ' ' : '', url: ' ' }))
            usingPlaceholderGifs = true
        }
        return (
            <Observer onVisibleChange={onVisible} fireOnce key={id} className={css.carousel}>
                <Carousel
                    className={className}
                    channelId={id}
                    maxBlocks={MAX_CAROUSEL_ITEMS}
                    {...{ isVisible, title, titleUrl, autoPlay, isPrivate }}
                >
                    {gifs.map((gif, index) => (
                        <ChannelCarouselItem
                            preloadIndex={preloadIndex++}
                            key={index}
                            {...{ gif, autoPlay, gridId: this.gridId, backgroundColor }}
                            itemIndex={{ index, max: MAX_CAROUSEL_ITEMS }}
                            isVideo={contentType === 'video'}
                        />
                    ))}
                </Carousel>
            </Observer>
        )
    }
}

const PaginationCarousels = ({ channels = [], autoPlay }) =>
    channels.map((channel, index) => <CarouselSection key={index} {...{ channel, index, autoPlay }} />)

PaginationCarousels.propTypes = {
    channels: PropTypes.arrayOf(channelProps),
}

export default PaginationCarousels
